module.exports = __webpack_public_path__ + "img/pngfind.com-cart-png-2727925.02800820.png";